module.exports = __webpack_public_path__ + "fonts/Inter-Bold.a956603b.woff";